import { groq } from "next-sanity";
import { useRouter } from "next/router";
import { createContext, useContext } from "react";
import useSanity from "./useSanity";

const CmsContext = createContext({});
const query = (locale) =>
  groq`*[_type == "cms"]{"id": id.current, "text": text.${locale || "en"} }`;

export const CmsProvider = ({ children }) => {
  const router = useRouter();
  const { data, isLoading, isError } = useSanity(query(router?.locale));

  return (
    <CmsContext.Provider value={{ data, isLoading, isError }}>
      {children}
    </CmsContext.Provider>
  );
};

export const useCMS = () => useContext(CmsContext);
